import { useTheme } from '@mui/material';
import { TextMDefaultWrapper } from './styles';
import { HTMLAttributes, ReactNode } from 'react';

export interface ITextMDefaultProps
  extends HTMLAttributes<HTMLParagraphElement> {
  children: ReactNode;
  weight?: 'Regular' | 'Bold' | 'Semibold' | 'Medium';
}

const fontWeightTypes = {
  Regular: 'Rg',
  Bold: 'B',
  Semibold: 'Sb',
  Medium: 'Md',
};

const TextM = ({
  children,
  weight = 'Regular',
  ...props
}: ITextMDefaultProps) => {
  const theme = useTheme();
  return (
    <TextMDefaultWrapper
      weight={weight}
      {...props}
      style={{
        ...props.style,
        fontWeight: theme.typography?.fontWeight?.[fontWeightTypes[weight]],
      }}
    >
      {children}
    </TextMDefaultWrapper>
  );
};

export default TextM;
